import { useState, useRef } from "react"
import { Global } from "../classes/global"
import { Player } from "../classes/player"
import { Spatialise } from "./Spatialise"

export function Fabric() {
	const [isPopUpVisible, setIsPopUpVisible] = useState(false)
	const [imageActive, setImageActive] = useState("assets/default_top.jpg")
	const refRadio = useRef<HTMLInputElement>(null)
	const refDropZone = useRef<HTMLDivElement>(null)
	const iconCloseSrc = "assets/CloseButton.svg"

	function ImagePopUp() {
		return (
			<div id="popUp" className="noSelect">
				<img src={imageActive} id="popUpImage" />
				<button id="closeButton">
					<img
						src={iconCloseSrc}
						onClick={() => setIsPopUpVisible(false)}
						className="closeButtonIcon"
					/>
				</button>
			</div>
		)
	}

	function changeTexture(e: React.ChangeEvent<HTMLInputElement>) {
		const file = e.target.files![0]
		const url = URL.createObjectURL(file)
		setImageActive(url)
		Global.showFabric = true
		Player.setFabric(url)
	}

	function onDragOverDropZone(e: React.DragEvent<HTMLDivElement>) {
		const items = e.dataTransfer?.items
		const type = items[0].type
		e.stopPropagation()
		e.preventDefault()
		if (type === "image/jpeg" || type === "image/png") {
			refDropZone.current?.classList.add("dropEffect")
		}
	}

	function onDropOverDropZone(e: React.DragEvent<HTMLDivElement>) {
		const items = e.dataTransfer?.items
		const type = items[0].type
		e.stopPropagation()
		e.preventDefault()
		if (type === "image/jpeg" || type === "image/png") {
			const url = URL.createObjectURL(items[0].getAsFile() as Blob)
			setImageActive(url)
			Global.showFabric = true
			Player.setFabric(url)
		}
		onDragLeaveDropZone()
	}

	function onDragLeaveDropZone() {
		refDropZone.current?.classList.remove("dropEffect")
	}

	return (
		<div className="tab" id="fabricTab">
			<input type="radio" ref={refRadio} name="accordion-2" id="rd1" />
			<label htmlFor="rd1" className="tab__label">
				Fabric
			</label>
			<div
				ref={refDropZone}
				className="tab__content"
				onDragOver={onDragOverDropZone}
				onDrop={onDropOverDropZone}
				onDragLeave={onDragLeaveDropZone}
			>
				<Spatialise
					position={[0, 2, 0]}
					colour="#000000"
					size={[20, 0.5]}
					parentID="UI_parent"
				>
					<p>
						You can upload an image for the outfit.
						<br />
						<strong>Note: </strong>Uploaded file is stored in memory, not on a
						server
					</p>
				</Spatialise>
				<div id="uploaderContent">
					<img
						id="uploadImage"
						src={imageActive}
						onClick={() => setIsPopUpVisible(true)}
					/>
					{isPopUpVisible && <ImagePopUp />}
					<p>Drag and drop JPG or PNG</p>
					<label htmlFor="inputUpload" style={{ display: "inline-block" }}>
						<span id="btnUpload">Upload</span>
					</label>
					<input
						type="file"
						onChange={changeTexture}
						id="inputUpload"
						accept=".jpg, .png, .jpeg, .bmp, .tif, .tiff|image/*"
					/>
				</div>
			</div>
		</div>
	)
}
